<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <div 
      class="mt-3 background-default pa-7">
      <div>
        <div class="title text--secondary mb-5">
          Tambah Materi
        </div>
        <ValidationObserver ref="observer">
          <v-form>
            <ValidationProvider name="Judul" rules="required" v-slot="{ errors }">
              <v-text-field
                outlined
                dense
                color="#ff618a"
                label="Judul"
                v-model="form.libraryTitle"
                :error-messages="errors"
                required>
              </v-text-field>
            </ValidationProvider>

            <ValidationProvider
              name="Kategori"
              rules="required"
              v-slot="{ errors }">
              <v-select
                dense
                outlined
                color="#ff618a"
                label="Kategori"
                :items="category"
                item-text="categoryTitle"
                item-value="id"
                v-on:change="changeCategory"
                v-model="form.libraryCategoryId"
                :error-messages="errors"
                required
              >
              </v-select>
            </ValidationProvider>
            <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
              <v-select
                :items="[
                  {
                    title: 'Draft', 
                    value: 'draft'
                  },
                  {
                    title: 'Publish', 
                    value: 'publish'
                  }
                ]"
                item-text="title"
                item-value="value"
                dense
                outlined
                color="#ff618a"
                label="Status"
                v-model="form.libraryStatus"
                :error-messages="errors"
                require>
              </v-select>
            </ValidationProvider>
            <v-label>
              Harga
            </v-label>
            <v-radio-group class="mt-1" v-model="price">
              <v-radio label="Berbayar" value="non-free" color="#ff618a">
              </v-radio>
              <v-row v-if="price === 'non-free'">
                <v-col cols="12" md="6">
                  <ValidationProvider
                    name="Harga"
                    rules="required|min_10000:10000|max_classPrice:100000000"
                    v-slot="{ errors }">
                     <v-currency-field 
                      outlined
                      dense
                      color="#ff618a"
                      type="number"
                      label="Harga"
                      :prefix="`Rp`"
                      v-model="form.libraryPrice"
                      :error-messages="errors"
                      required/>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6">
                  <ValidationProvider
                    name="Diskon"
                    rules="min_0:0|max_100:100"
                    v-slot="{ errors }">
                    <v-text-field
                      outlined
                      dense
                      color="#ff618a"
                      type="number"
                      label="Diskon"
                      v-model="form.libraryDiscount"
                      :error-messages="errors">
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-radio label="Gratis" value="free" color="#ff618a" class="mb-0">
              </v-radio>
              <v-card-text
                class="caption text-justify py-1 ml-4 font-italic"
                v-if="price === 'free'"
              >
                Kelas anda sekarang berstatus <b>Gratis</b>, sehingga pengguna
                dapat mengambil secara gratis. Apakah anda yakin untuk membuat
                kelas gratis ?
              </v-card-text>
            </v-radio-group>
            <ValidationProvider name="Type" rules="required" v-slot="{ errors }">
                <v-select
                  :items="[
                    {
                      title: 'Public', 
                      value: 'public'
                    },
                    {
                      title: 'Private', 
                      value: 'private'
                    }
                  ]"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  color="#ff618a"
                  label="Tipe"
                  v-model="form.libraryType"
                  :error-messages="errors"
                  require>
                </v-select>
            </ValidationProvider>
             <ValidationProvider name="Format" rules="required" v-slot="{ errors }">
                <v-select
                  :items="[
                    {
                      title: 'Video', 
                      value: 'video'
                    },
                    {
                      title: 'Pdf', 
                      value: 'pdf'
                    }
                  ]"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  color="#ff618a"
                  label="Format"
                  v-model="form.libraryFormat"
                  :error-messages="errors"
                  require>
                </v-select>
            </ValidationProvider>
            <p class="mb-1 mt-3">Deskripsi</p>
            <quill-editor 
              ref="myTextEditor" 
              v-model="form.libraryDesc"
              :options="option">
            </quill-editor>
            <p class="caption mt-1 mb-1 red--text"
              v-show="error.libraryDesc">
              {{ error.libraryDesc }}
            </p>

            <div class="mb-3 mt-4" v-if="form.libraryFormat === 'video'">
              <p class="mb-2">Video Overview</p>
              <form class="mt-1">
                <v-card
                  flat
                  width="400"
                  height="250"
                  class="pa-0"
                  style="background: transparent;">
                  <video-input v-model="video" >
                    <div slot="activator">
                      <v-avatar 
                        width="400"
                        height="220"
                        class="grey lighten-3 cursor-pointer"
                        v-ripple 
                        tile
                        v-if="!video || video.url === undefined">
                        <v-icon v-if="!video && addVideo === ''" color="grey darken-3" large>mdi-video-plus</v-icon>
                        <div v-if="addVideo && video.url === undefined">
                          <v-progress-linear
                            color="#ff618a"
                            indeterminate
                            rounded
                            height="6"
                            style="width: 200px;">
                          </v-progress-linear>
                          <p class="caption mt-2 mb-0 pink--text">
                            Menunggu data . . .
                          </p>
                        </div>
                      </v-avatar>
                    </div>
                  </video-input>
                  <p class="caption text-left mt-1 red--text"
                    v-show="error.libraryFile">
                    {{ error.libraryFile }}
                  </p>
                  <video
                    id="myVideo"
                    height="200px"
                    width="100%" 
                    :src="video.url"
                    playsinline 
                    controls
                    v-if="video && !addVideo">
                  </video>
                  <video-input v-model="video" >
                    <div slot="activator">
                      <v-btn
                        rounded
                        light
                        width="100%"
                        color="#ff618a"
                        elevation="0"
                        :disabled="addVideo || process.run"
                        :loading="addVideo"
                        @click="save"
                        v-if="addVideo !== '' && video.url !== undefined"
                        class="white--text text-capitalize">
                        Ganti Video
                      </v-btn>
                    </div>
                  </video-input>
                </v-card>
              </form>
            </div>

            <div class="mb-3 mt-4" v-if="form.libraryFormat === 'pdf'">
              <p class="mb-2">File Pdf</p>
              <form class="mt-1">
                <v-card
                  flat
                  width="400"
                  height="250"
                  class="pa-0"
                  style="background: transparent;">
                  <file-input
                    v-model="files" >
                    <div slot="activator">
                      <v-avatar 
                        width="400"
                        height="220"
                        class="grey lighten-3 cursor-pointer"
                        v-ripple 
                        tile
                        v-if="!files || files.url === undefined">
                        <v-icon v-if="!files && addFiles === ''" color="grey darken-3" large>mdi-file</v-icon>
                        <div v-if="addFiles && files.url === undefined">
                          <v-progress-linear
                            color="#ff618a"
                            indeterminate
                            rounded
                            height="6"
                            style="width: 200px;">
                          </v-progress-linear>
                          <p class="caption mt-2 mb-0 pink--text">
                            Menunggu data . . .
                          </p>
                        </div>
                      </v-avatar>
                    </div>
                  </file-input>
                  <p class="caption text-left mt-1 red--text"
                    v-show="error.libraryFile">
                    {{ error.libraryFile }}
                  </p>
                  <div v-if="files && !addFiles">
                    <iframe 
                      width="500" 
                      height="200px" 
                      :src="files.url" 
                      frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen>
                    </iframe>
                  </div>
                  <file-input
                    v-model="files" >
                    <div slot="activator">
                      <v-btn
                        rounded
                        light
                        width="100%"
                        color="#ff618a"
                        elevation="0"
                        :disabled="addFiles || process.run"
                        :loading="addFiles"
                        @click="save"
                        v-if="addFiles !== '' && files.url !== undefined"
                        class="white--text text-capitalize">
                        Ganti files
                      </v-btn>
                    </div>
                  </file-input>
                </v-card>
              </form>
            </div>

            <div class="mb-3 mt-4">
              <p class="mb-2">Gambar Sampul</p>
              <form class="mt-1">
                <v-card
                  flat
                  width="250"
                  height="250"
                  class="pa-0"
                  style="background: transparent;">
                  <image-input v-model="avatar" type="uploadCover">
                    <div slot="activator">
                      <v-avatar 
                        width="250"
                        height="250"
                        class="grey lighten-3 cursor-pointer"
                        v-ripple 
                        tile>
                        <v-icon v-if="!avatar && addImage === ''" color="grey darken-3"  large>mdi-camera</v-icon>
                        <div v-if="addImage && avatar.url === undefined">
                          <v-progress-linear
                            color="#ff618a"
                            indeterminate
                            rounded
                            height="6"
                            style="width: 200px;">
                          </v-progress-linear>
                          <p class="caption mt-2 mb-0">
                            Mengupload Gambar . . .
                          </p>
                        </div>
                        <img 
                          v-if="avatar && !addImage"
                          :src="form.libraryCover" 
                          :alt="form.libraryCover">
                      </v-avatar>
                    </div>
                  </image-input>
                </v-card>
              </form>
              <p class="caption text-left mt-1 red--text"
                v-show="error.libraryCover">
                {{ error.libraryCover }}
              </p>
            </div>
            <div>
              <v-alert 
                type="error" 
                text
                dense
                prominent
                v-show="response !== ''">
                {{ response }}
              </v-alert>
            </div>
            <v-card-actions class="mt-5">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                light
                :width="$vuetify.breakpoint.name === 'lg' ? '200' : '100'"
                color="#ff618a"
                elevation="0"
                :disabled="process.run"
                :loading="process.run"
                @click="save"
                class="white--text text-capitalize">
                Simpan
              </v-btn>
              <v-btn
                rounded
                outlined
                light
                :width="$vuetify.breakpoint.name === 'lg' ? '200' : '100'"
                elevation="0"
                :disabled="process.run"
                class="text-capitalize"
                to="/library">
                Batal
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import ImageInput from '../../../components/ImageInput.vue';
  import VideoInput from '../../../components/VideoInput.vue';
  import FileInput from '../../../components/FileInput.vue';
  import pdf from 'vue-pdf'
  // import Empty from "../../../../components/DataEmpty"; 
  export default {
    data () {
      return {
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'direction': 'rtl' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'font': [] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }],
              ['clean'],
              ['link', 'image', 'video']
            ]
          },
          placeholder: 'Deskripsi . . .'
        },
        detail: {},
        category:[],
        avatar: null,
        video: null,
        files:null,
        price: "non-free",
        addFiles:'',
        addVideo: '',
        addImage: '',
        form: {
          libraryCategoryId:'',
          libraryCategoryTitle: '',
          libraryTitle: '',
          libraryDesc: '',
          libraryDuration: '',
          libraryCover: '',
          libraryFile: '',
          libraryPrice:'',
          libraryStatus:'',
          libraryType: '',
          libraryFormat: 'video',
          libraryDiscount: 0
        },
        error: {
          libraryDesc: '',
          libraryCover: '',
          libraryFile: ''
        },
        process: {
          run: false
        },
        response: ''
      }
    },
    head() {
    },
    watch:{
      avatar: {
        handler: function () {
          this.form.libraryCover = this.avatar.url
          this.addImage = this.avatar.add
          this.error.libraryCover = ''
        },
        deep: true
      },
      video: {
        handler: function () {
          this.form.libraryFile = this.video.url
          this.form.libraryDuration = this.video.duration
          this.addVideo = this.video.add
          this.error.libraryFile = ''
        },
        deep: true
      },
      files: {
        handler: function () {
          this.form.libraryFile = this.files.url
          this.error.libraryFile = ''
          this.addFiles = this.files.add
        },
        deep: true
      }
    },
    components: {
      ImageInput,
      VideoInput,
      FileInput,
      pdf
    },
    computed: {},
    mounted () {
      window.scrollTo(0, 0)
      if (this.$route.query.id !== undefined) {
        this.fetch()
      }else{
        this.fetchCategory()
      }
    },   
    methods: { 
      async fetch() {
        await get(`api/internal/library/detail/${this.$route.query.id}`)
        .then((response) => {
          if (response.data.code === 200) {
            this.detail = response.data.data
            this.fetchCategory()
            this.reset()
          }
        })
      },
      async fetchCategory() {
      this.process.run = true;
      await get(`api/internal/category/list`).then((response) => {
        let res = response.data;
        if (res.code === 200) {
          this.category = res.data;
        }
        this.process.run = false;
      });
      },
      // changeFormat(){
      //   if(this.form.libraryFormat === 'video'){

      //   }else if(this.form.libraryFormat === 'pdf'){

      //   }
      // },
      changeCategory() {
      for (let i in this.category) {
        if (this.category[i].id === this.form.libraryCategoryId) {
          this.form.libraryCategoryTitle = this.category[i].categoryTitle;
        }
      }
      },
      validation() {
        var error = this.error,
            valid = true
        
        if (this.form.libraryDesc === '') {
          error.libraryDesc = 'Kolom tidak boleh kosong'
          valid = false
        } else {
          error.libraryDesc = ''
        }

         if (this.form.libraryCover === '') {
          error.libraryCover = 'Gambar tidak boleh kosong'
          valid = false
        } else if (this.form.libraryCover === undefined) {
          error.libraryCover = 'Gambar tidak boleh kosong'
          valid = false
        } else {
          error.libraryCover = ''
        }

        if (this.form.libraryFile === '') {
          error.libraryFile = 'File tidak boleh kosong'
          valid = false
        } else if (this.form.libraryFile === undefined) {
          error.libraryFile = 'File tidak boleh kosong'
          valid = false
        }else {
          error.libraryFile = ''
        }

        
        return valid;
      },
      reset(item) {
        this.files = {
          url: this.detail.libraryUrlFile
        };
        this.avatar = {
          url: this.detail.libraryUrlCover  
        };
        this.video = {
          url: this.detail.libraryUrlFile,
        };
        this.form = {
          libraryTitle: this.detail.libraryTitle,
          libraryCategoryId: this.detail.libraryCategoryId,
          libraryCategoryTitle: this.detail.libraryCategoryTitle,
          libraryDesc: this.detail.libraryDesc.replace(/&lt;/g, '<'),
          libraryPrice:this.detail.libraryPrice === 0 ? (this.price = "free"): (this.price = "non-free"),
          libraryDiscount: this.detail.libraryDiscount,
          libraryStatus: this.detail.libraryStatus,
          libraryDuration : this.form.libraryFile === this.video.url ? this.detail.libraryDuration : this.form.libraryDuration,
          libraryCover: this.detail.libraryUrlCover,
          libraryFormat: this.detail.libraryFormat,
          libraryType: this.detail.libraryType
        };
        if (this.price === 'non-free') {
        this.form.libraryPrice = this.detail.libraryPrice
        } else {
        this.form.libraryPrice = 0
      }
      },
      async save() {
        this.response = ''
        const valids = this.validation()
        const isValid = await this.$refs.observer.validate()
        if (isValid & valids) {
          if (this.$route.query.id === undefined) {
            this.creates()
          } else {
            this.updates()
          }
        }
      },
      async creates() {
        this.process.run = true
        await post(`api/internal/library/create`, {
          data: {
            classesId: this.$route.query.class !== undefined ? this.$route.query.class : '',
            silabusId: this.$route.query.silabus !== undefined ? this.$route.query.silabus : '',
            libraryTitle : this.form.libraryTitle,
            libraryDesc : this.form.libraryDesc,
            libraryCategoryId: this.form.libraryCategoryId,
            libraryCategoryTitle: this.form.libraryCategoryTitle,
            libraryType : this.form.libraryType,
            libraryFormat : this.form.libraryFormat,
            libraryPrice: this.price === "free" ? 0 : this.form.libraryPrice,
            libraryDiscount: this.form.libraryDiscount === "" ? 0 : this.form.libraryDiscount,
            libraryUrlCover : this.form.libraryCover,
            libraryUrlFile : this.form.libraryFile,
            libraryStatus : this.form.libraryStatus,  
            libraryDuration : this.form.libraryDuration,
            libraryStatus: this.form.libraryStatus
          }
        })
        .then((response) => {
          if (response.data.code === 201) {
            const url = `/library/${response.data.data}`
            this.$router.push(url)
          } else {
            this.process.run = false
            this.response = response.data.msg
          }
        })
      },
      async updates() {
        this.process.run = true
        await put(`api/internal/library/update/${this.$route.query.id}`, {
          data: {
            libraryTitle : this.form.libraryTitle,
            libraryDesc : this.form.libraryDesc,
            libraryType : this.form.libraryType,
            libraryCategoryId: this.form.libraryCategoryId,
            libraryCategoryTitle: this.form.libraryCategoryTitle,
            libraryPrice: this.price === "free" ? 0 : this.form.libraryPrice,
            libraryUrlCover : this.form.libraryCover,
            libraryFile : this.form.libraryFile,
            libraryStatus : this.form.libraryStatus,  
            libraryDuration : this.form.libraryDuration,
            libraryDiscount: this.form.libraryDiscount === "" ? 0 : this.form.libraryDiscount,
            libraryFormat : this.form.libraryFormat,
          }
        })
        .then((response) => {
          if (response.data.code === 201) {
            const url = `/library/${this.$route.query.id}`
            this.$router.push(url)
          } else {
            this.process.run = false
            this.response = response.data.msg
          }
        })
      }
    }
  }
</script>
